<form [formGroup]="fg" (ngSubmit)="submit()">

    <mat-form-field appearance="fill" class="no_top_spacing" hideRequiredMarker>
        <mat-label>Nombre</mat-label>
        <input matInput formControlName="name" name="fullName" autocomplete="name" autocapitalize="words">
        <form-field-lock matSuffix></form-field-lock>
        <mat-error *ngIf="fcName.hasError('required')">Requerido</mat-error>
        <mat-error *ngIf="fcName.hasError('minlength')">Mínimo 2 caracteres</mat-error>
        <mat-error *ngIf="fcName.hasError('maxlength')">Máximo 80 caracteres</mat-error>
    </mat-form-field>

    <mat-form-field appearance="fill" class="no_top_spacing" hideRequiredMarker>
        <mat-label>Correo electrónico</mat-label>
        <input matInput type="email" name="email" formControlName="email">
        <form-field-lock matSuffix></form-field-lock>
		<mat-error *ngIf="fcEmail.hasError('required')">Requerido</mat-error>
        <mat-error *ngIf="fcEmail.hasError('email')">Correo inválido</mat-error>
    </mat-form-field>

    <mat-form-field appearance="fill" class="no_top_spacing" hideRequiredMarker>
        <mat-label>Dejanos tu mensaje</mat-label>
        <textarea matInput rows="5" formControlName="message" autocomplete="off" autocapitalize="on"></textarea>
        <form-field-lock matSuffix></form-field-lock>
		<mat-error *ngIf="fcMessage.hasError('required')">Requerido</mat-error>
		<mat-error *ngIf="fcMessage.hasError('maxlength')">Máximo 800 caracteres</mat-error>
    </mat-form-field>

    <app-action-button
        [bDisabled]="fg.invalid"
        [bWorking]="fg.disabled"
        [idleCaption]="'ENVIAR MENSAJE'"
        [busyCaption]="'ENVIANDO'"
    ></app-action-button>
</form>